import React, { PropTypes } from 'react';

import AutoTaskInputUsersOverview from './AutoTaskInputUsersOverview';
import AutoProjectInput from './AutoProjectInput';
import AutoTaskInput from './AutoTaskInput';

class UsersOverviewUserPillNewAssignmentBar extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render = () => {
        return (
            <div className="form-group">
                <br/>
                <div className="row">
                    <div className={this.props.projectError ? "col-sm-4 has-error" : "col-sm-4"}>
                        <AutoProjectInput
                            clearInputs={this.props.clearInputs}
                            disableTab
                            enableClear
                            hideArchived
                            keepAfterClick
                            placeholder="Project Name"
                            projects={this.props.projects}
                            />
                    </div>
                    <div onFocus={this.props.handleNewTaskInputFocus} className={this.props.taskError ? "col-sm-5 has-error" : "col-sm-5"}>
                        <AutoTaskInput
                            clearInputs={this.props.clearInputs}
                            disableTab
                            enableClear
                            hideClosed
                            hideArchived
                            forceInitialPopup={false}
                            oneline
                            placeholder="Task Name"
                            tasks={this.props.tasks}
                            />
                    </div>
                    <div className="col-sm-2">
                        <input
                            ref="quotaInput"
                            type="text"
                            value={this.props.newUTQuota}
                            onChange={this.props.handleNewQuotaChange}
                            className="form-control"
                            id="project-person-hours"
                            placeholder="Hours"
                            />
                        { this.props.newUTQuota ? 
                                <a style={{"cursor" : "pointer", "paddingRight" : "20px", "paddingTop" : "5px"}} onClick={this.props.clearNewQuota} className="filter-clear">
                                <span>
                                    <span className="md-clear"/>
                                </span>
                                </a>
                            : null
                        }
                            
                    </div>
                    <div className="col-sm-1">
                        <button title="Add user to task" onClick={this.props.handleCreateUserTask} style={{"background" : "transparent" , "border" : "none"}}>
                            <a className="icon-btn">
                                <span>
                                    <span className="md-done"/>
                                </span>
                            </a>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

UsersOverviewUserPillNewAssignmentBar.propTypes = {
    clearNewQuota: PropTypes.func,
    handleCreateUserTask: PropTypes.func,
    handleNewQuotaChange: PropTypes.func,
    handleNewTaskInputFocus: PropTypes.func,
    handleProjectSelect: PropTypes.func,
    handleTaskSelect: PropTypes.func,

    projectError: PropTypes.bool,
    projects: PropTypes.array,
    taskError: PropTypes.bool,
    newUTProject: PropTypes.object,
    tasks: PropTypes.array,
    newUTQuota: PropTypes.number,
};

export default UsersOverviewUserPillNewAssignmentBar;



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverviewUserPillNewAssignmentBar.js
 **/